import * as React from 'react';
import { useSelector } from 'react-redux';

import { DealTypeFilterContainer } from '../../containers/DealTypeFilterContainer';
import { EntityTypeToggleContainer } from '../../containers/EntityTypeToggleContainer';
import {
  FoldersUnsupportedModalContainer,
  FoldersUnsupportedModalContainerV2,
} from '../../containers/FoldersUnsupportedModalContainer';
import { ResultsEmptyContainer } from '../../containers/ResultsEmpty';
import { ResultsMobileContainer } from '../../containers/ResultsMobileContainer';
import { ShowMoreBtnContainer } from '../../containers/ShowMoreBtnContainer';
import { selectIsMobileBannerFrequencyExperimentEnabled } from '../../selectors/experiments/selectIsMobileBannerFrequencyExperimentEnabled';
import { selectIsUnsupportedModalAvailable } from '../../selectors/unsupportedModal';

export const MobilePage = () => {
  const mobileBannerFrequencyExperimentEnabled = useSelector(selectIsMobileBannerFrequencyExperimentEnabled);
  const isModalAvailable = useSelector(selectIsUnsupportedModalAvailable);

  return (
    <>
      <DealTypeFilterContainer />
      <EntityTypeToggleContainer />
      <ResultsMobileContainer />
      <ResultsEmptyContainer />
      <ShowMoreBtnContainer />

      {mobileBannerFrequencyExperimentEnabled ? (
        <FoldersUnsupportedModalContainerV2 isModalAvailable={isModalAvailable} />
      ) : (
        <FoldersUnsupportedModalContainer />
      )}
    </>
  );
};
